__turbopack_context__.v({
  "bar": "QmvM3G_bar",
  "barcontainer": "QmvM3G_barcontainer",
  "container": "QmvM3G_container",
  "text": "QmvM3G_text",
});
